<template>
  <div>
    <span v-html="content"></span>
    <!-- <h1 class="text-2xl font-semibold">Impressum</h1>

    <div class="py-8">
      <p class="font-semibold">Anbieter der Artikel auf www.homeface.de</p>
      <p class="font-semibold">Homeface GmbH</p>
      <p class="font-semibold">Rösrather Straße 265</p>
    </div>
    <div class="py-8">
      <p class="font-semibold">vertreten durch die Geschäftsführerin: Ganimete Canolli</p>
      <p class="font-semibold">Telefon: +49 176 840 856 21</p>
      <p class="font-semibold">E-Mail: info@homeface.de</p>
    </div>
    <div class="py-8">
      <p class="font-semibold">Amtsgericht: Köln</p>
      <p class="font-semibold">Handelsregisternummer: B 89902</p>
      <p class="pt-4 font-semibold">USt-ID-Nr: DE 314956986</p>
    </div>-->
  </div>
</template>

<script>
import axios from "axios";

export default {
  data() {
    return {
      content: "",
    };
  },
  created() {
    this.getData();
  },
  methods: {
    getData() {
      axios.get(`${process.env.VUE_APP_API}/pages`).then((response) => {
        // console.log(response);
        if (response.data.data[1].name === "impressum") {
          this.content = response.data.data[1].description;
          console.log(this.content);
        }
      });
    },
  },
};
</script>

<style>
</style>